import {fetchAssociateMetrics, fetchAssociateMetricsV2} from "../network/AssociateNetworkAPI";

export const AssociatePerformanceReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {dispatcher, baseUrl, stationConfig} = action.data;
            if (stationConfig && stationConfig.parallelPickEnabled) {
                fetchAssociateMetricsV2(dispatcher, baseUrl, stationConfig);
            } else {
                fetchAssociateMetrics(dispatcher, baseUrl, stationConfig);
            }
            return state;
        case "RECEIVE_DATA":
            return {...state, ...action.data};
        case "SORT_DATA":
            return {...state, sortPref: action.data};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/pickassociate/reducers/AssociatePerformanceReducer.js